module.exports = __webpack_public_path__ + "img/task-5.7dba8919.png";